import * as React from 'react';
import { Container, Box } from '@mui/material';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import ConfirmationForm from './ConfirmationForm';
import ForgotPasswordForm from './ForgotPasswordForm';

type AuthMode = 'login' | 'signup' | 'confirmation' | 'forgot-password';

export default function AuthContainer() {
  const [mode, setMode] = React.useState<AuthMode>('login');
  const [signUpUsername, setSignUpUsername] = React.useState('');

  const handleSwitchToLogin = () => setMode('login');
  const handleSwitchToSignUp = () => setMode('signup');
  const handleSwitchToForgotPassword = () => setMode('forgot-password');
  
  const handleSignUpSuccess = (username: string) => {
    setSignUpUsername(username);
    setMode('confirmation');
  };
  
  const handleConfirmationSuccess = () => {
    setMode('login');
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        {mode === 'login' && (
          <LoginForm 
            onSwitchToSignUp={handleSwitchToSignUp}
            onSwitchToForgotPassword={handleSwitchToForgotPassword}
          />
        )}
        
        {mode === 'signup' && (
          <SignUpForm 
            onSwitchToLogin={handleSwitchToLogin}
            onSignUpSuccess={handleSignUpSuccess}
          />
        )}
        
        {mode === 'confirmation' && (
          <ConfirmationForm 
            username={signUpUsername}
            onConfirmationSuccess={handleConfirmationSuccess}
            onSwitchToLogin={handleSwitchToLogin}
          />
        )}
        
        {mode === 'forgot-password' && (
          <ForgotPasswordForm 
            onSwitchToLogin={handleSwitchToLogin}
          />
        )}
      </Box>
    </Container>
  );
}